import { Grid } from "@mui/material";
import Switch from "@mui/material/Switch";
import React, { useState } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Editor from "../../../Editor/Editor";
import { updateOptionsForUser, getCookie } from "../../../Url";
import { isDeveloper } from "../../Tools/Tools";
import { useAtom } from "jotai";
import {
  animationsAtom,
  currentTheme,
  gridSelectedRecordColorAtom,
  hideToastNotificationsAtom,
} from "../../../../atoms";
import { toast } from "react-toastify";

// список для редактора
function getListForThemeEditor() {
  return [
    { label: "Бежевая", id: 0 },
    { label: "Синяя", id: 1 },
  ];
}

const localizeThemeEn = {
  Бежевая: "light",
  Синяя: "blue",
};

const localizeThemeRu = {
  light: "Бежевая",
  blue: "Синяя",
};

export default function ThemeChange(props) {
  const [animation, setAnimations] = useAtom(animationsAtom);
  const [hideToastNotifications, setHideToastNotifications] = useAtom(hideToastNotificationsAtom);
  const [gridSelectedRecordColor, setGridSelectedRecordColorAtom] = useAtom(gridSelectedRecordColorAtom);
  const [theme, setTheme] = useAtom(currentTheme);
  // текст для темы
  const [themeVal, setThemeVal] = useState(localizeThemeRu[theme]);

  function onEditTheme(data) {
    setThemeVal(data.value);

    // обновление внутренних данных редактора
    data.setValue({ label: data.value, id: data.tag });
    // если инпут не контролируемый то нужно обновлять значение тут:
    // data.setInputValue(data.value);
    setTheme(localizeThemeEn[data.value]);
    updateOptionsForUser({ theme: localizeThemeEn[data.value] });
  }
  return (
    <Grid container direction={"column"} justifyContent={"center"} alignItems={"flex-start"} sx={{ m: 0, pl: 2 }}>
      <Grid item>
        <FormControlLabel
          control={
            <Switch
              disabled={!isDeveloper()}
              checked={animation}
              onChange={(event) => {
                setAnimations(event.target.checked);
                updateOptionsForUser({ animations: event.target.checked });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          sx={{ display: "none" }}
          label="Анимации"
          labelPlacement="end"
        />
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Switch
              checked={hideToastNotifications}
              onChange={(event) => {
                setHideToastNotifications(event.target.checked);
                updateOptionsForUser({ hideToastNotifications: event.target.checked });
                if (event.target.checked) toast.dismiss();
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          label="Скрыть всплывающие уведомления"
          labelPlacement="end"
        />
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Switch
              checked={gridSelectedRecordColor}
              onChange={(event) => {
                setGridSelectedRecordColorAtom(event.target.checked);
                updateOptionsForUser({ gridSelectedRecordColor: event.target.checked });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          label="Выделять запись цветом в таблице"
          labelPlacement="end"
        />
      </Grid>
      <Grid
        style={{
          height: "27px",
          width: "250px",
          display: "none",
          alignItems: "center",
        }}
        item
      >
        <div style={{ width: "50px" }}>Тема:</div>
        <div
          style={{
            height: "27px",
            border: "1px solid #eeeeee",
          }}
        >
          <Editor
            // контролируемый input с помощью состояния
            value={themeVal}
            // функиця редактирования
            onEdit={onEditTheme}
            // стиль выпадающего списка = 1
            editStyle={65}
            // первый вариант списка
            onDropDownList={getListForThemeEditor}
            // альтернативный вариант списка
            // list={"Текущая тема\r\nТема 2"}
          />
        </div>
      </Grid>
    </Grid>
  );
}
